<template>
  <div class="app-main">
    <el-card class="box-card" shadow="hover">
      <RegisterInfo :preview="true" :basicId="basicId" :otherInfo="otherInfo"></RegisterInfo>
      <YwInfo :preview="true" :basicId="basicId" :otherInfo="otherInfo"></YwInfo>
      <JyClassify :preview="true" :basicId="basicId" :otherInfo="otherInfo"></JyClassify>
      <LxrInfo :preview="true" :basicId="basicId" :otherInfo="otherInfo"></LxrInfo>
      <Address :preview="true" :basicId="basicId" :otherInfo="otherInfo"></Address>
      <BankInfo :preview="true" :basicId="basicId" :otherInfo="otherInfo"></BankInfo>
      <InvoiceInfo :preview="true" :basicId="basicId" :otherInfo="otherInfo"></InvoiceInfo>
      <CwInfo :preview="true" :basicId="basicId" :otherInfo="otherInfo"></CwInfo>
      <FileInfo :preview="true" :basicId="basicId" :otherInfo="otherInfo"></FileInfo>
    </el-card>
    <div class="foot-btn">
        <el-button type="primary" v-if="checkRole('gysWaitAudit')" :disabled="status!=0" @click="submitAudit()" size="small">提交注册信息</el-button>
        <el-button type="primary" v-if="checkRole('gys_role') || checkRole('cgy_role') || checkRole('gys_audit')" :disabled="status!=0" @click="submitAudit(1)" size="small">提交变更信息</el-button>
      </div>
  </div>
</template>

<script>
import { submitAuditBasicInfo,supplierInfoById } from '@/api/gys/supplierInfo.js';
import RegisterInfo from '@/components/Gys/RegisterInfo.vue'
import YwInfo from '@/components/Gys/YwInfo.vue'
import JyClassify from '@/components/Gys/JyClassify.vue'
import LxrInfo from '@/components/Gys/LxrInfo.vue'
import Address from '@/components/Gys/Address.vue'
import BankInfo from '@/components/Gys/BankInfo.vue'
import InvoiceInfo from '@/components/Gys/InvoiceInfo.vue'
import CwInfo from '@/components/Gys/CwInfo.vue'
import FileInfo from '@/components/Gys/FileInfo.vue'

export default {
  name: "PreView",
  components: {
    RegisterInfo,
    YwInfo,
    JyClassify,
    LxrInfo,
    Address,
    BankInfo,
    InvoiceInfo,
    CwInfo,
    FileInfo
  },
  props: {
    basicId: {
      type: Number,
    },
    otherInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      status:0,
    }
  },
  created(){
    this.geGysInfo()
  },
  methods:{
    async geGysInfo(id) {
      let _this = this;
      const { data: res } = await supplierInfoById({
          id: _this.basicId
      })
      if (res.code == 0) {
          _this.status = res.data.status;
      }
    },
    submitAudit(type){
        let _this = this;
        _this.confirm({
            text: '是否确认提交审核',
            tip: '提示',
            type: 'info',
            fn: function(param) {
              console.log('提及审核')
              console.log(param)
              let par = {...param}
              if(type){
                par['changeType'] = 'E'
              }
              submitAuditBasicInfo(par).then(({data:res})=>{
                  _this.$success('提交审核成功');
                  // _this.geGysInfo();
                  _this.$router.push({path: '/gys/info'});
              })
            },
            data: {
                id: this.basicId,
                status:1,
            } //参数对象 主要回调函数用
        });
      },
  },


}
</script>
<style scoped="scoped">
/**
      * 全屏弹框 不滚动
      */
.el-dialog__wrapper {
  overflow: hidden;
}

.newDialog ::v-deep .el-dialog__body {
  overflow: auto;
  height: calc(100vh - 120px);
  /*头+padding10 +加尾+padding10 + 2px 边框*/
}
.foot-btn{
  text-align: center;
  padding: 20px 0;
}
</style>
